<template>
  <div>
    <div class="source">
      <el-row class="querypanel">
        <el-col :span="12">
          <el-form ref="form"  label-width="120px" label-position="left" >
            <el-form-item label="客户名称">
              <el-input v-model="query_cusname" placeholder="请输入客户名称"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <el-form ref="form"  label-width="150px" style="margin-left: 20px" label-position="left">
            <el-form-item label="营业执照编号">
              <el-input v-model="query_cusno" placeholder="请输入营业执照号"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="24">
          <div>
            <el-button @click="querycus">查询</el-button>
            <el-button @click="createcus">创建新客户</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="tablepanel"><el-table
            v-loading="loading"
            stripe
            :data="mycidata"
            ref="multipleTable"
            @selection-change="handleSelectionChange">
            <el-table-column
              min-width="30px"
              prop="id"
              label="编号"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="客户名称">
            </el-table-column>
            <el-table-column
            prop="blnum.String"
            label="营业执照号">
            </el-table-column>
            <el-table-column
              label="审核状态"
              min-width="60px">
              <template slot-scope="scope">
                <div v-if="scope.row.state.Valid">
                    已审核
                </div>
                <div v-else>
                    未审核
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              min-width="80px"
            >
              <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="查看客户详细信息" placement="top-start">
                    <i class="fa fa-eye fa-lg ciicon curpointer" v-on:click="see(scope.row)"></i>
                  </el-tooltip>
                <el-tooltip class="item" effect="dark" content="审核确认" placement="top-start">
                  <i class="fa fa-check-square-o fa-lg ciicon curpointer" v-on:click="examine(scope.row)"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="注销客户信息" placement="top-start">
                  <i class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="cancel(scope.$index, mycidata)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          </div>
          <el-pagination
            ref="elpage"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[size]"
            :page-size=size
            layout="total, sizes, prev, pager, next, jumper"
            :total=total>
          </el-pagination>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12"><div class="grid-content bg-purple"></div></el-col>
        <el-col :span="12"><div class="grid-content bg-purple-light"></div></el-col>
      </el-row>
    </div>
    <el-dialog title="客户信息" :visible.sync="ciformvisible">
      <el-tabs   @tab-click="tbclick">
        <el-tab-pane label="客户信息" >
          <el-collapse v-model="activeNames" accordion >
            <el-collapse-item title="基本信息" name="1">
              <div>请在此客户的基本信息</div>
              <el-form ref="form"  label-width="150px" label-position="left" class="tabcard">
                <el-form-item label="客户名称">
                  <el-input  v-model="cusname" placeholder="请输入客户名称"></el-input>
                </el-form-item>
                <el-form-item label="营业执照号">
                  <el-input v-model="blnum" placeholder="请输入营业执照编号（三证合一）"></el-input>
                </el-form-item>
                <el-form-item label="注册地址">
                  <el-input v-model="raddress" placeholder="请输入营业执照注册地址"></el-input>
                </el-form-item>
                <el-form-item label="经营地址">
                  <el-input v-model="maddress" placeholder="请输入实际的经营地址"></el-input>
                </el-form-item>
                <el-form-item label="上传营业执照" class="yyzz_upload">
                  <el-upload
                    class="avatar-uploader"
                    drag
                    action="https://api.sqnetsoft.cn/ossupload/uploadoss"
                    :data="upparams"
                    :on-success="OnBlSuccess"
                    :on-error="OnBlError"
                    :before-upload="BeforeBlUpload">
                    <img v-if="blimgurlok" :src="blimgurl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
              </el-form>
            </el-collapse-item>
            <el-collapse-item title="法人信息" name="2">
              <div>请在此客户的法人信息</div>
              <el-form ref="form"  label-width="150px" label-position="left" class="tabcard">
                <el-form-item label="姓名">
                  <el-input v-model="lpname" placeholder="请输入法人姓名"></el-input>
                </el-form-item>
                <el-form-item label="身份证号">
                  <el-input v-model="lpno" placeholder="请输入法人身份证号"></el-input>
                </el-form-item>
                <el-form-item label="联系方式">
                  <el-input v-model="lpphone" placeholder="请输入法人的手机号码"></el-input>
                </el-form-item>
                <el-form-item label="上传身份证(正面)" class="yyzz_upload">
                  <el-upload
                    class="avatar-uploader"
                    drag
                    action="https://api.sqnetsoft.cn/ossupload/uploadoss"
                    :data="upparams"
                    :on-success="OnLpSuccess"
                    :on-error="OnLpError"
                    :before-upload="BeforeLpUpload">
                    <img v-if="lpimgurlok" :src="lpimgurl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
                <el-form-item label="上传身份证(反面)" class="yyzz_upload">
                  <el-upload
                    class="avatar-uploader"
                    drag
                    action="https://api.sqnetsoft.cn/ossupload/uploadoss"
                    :data="upparams"
                    :on-success="OnLpBackSuccess"
                    :on-error="OnLpBackError"
                    :before-upload="BeforeLpBackUpload">
                    <img v-if="lpbackimgurlok" :src="lpbackimgurl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
              </el-form>
            </el-collapse-item>
          </el-collapse>
          <div class="savebasepanel">
            <el-button type="primary" @click="savecusinfo">保存信息</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="客户资料">
          <el-collapse v-model="activekhzl" accordion >
            <el-collapse-item title="合同相关资料" name="1">
              <el-row class="querypanel">
                <el-col :span="24"><div class="queryinput">
                  <el-form ref="form"  label-width="150px" label-position="left" class="tabcard">
                    <el-form-item label="上传合同资料" class="yyzz_upload">
                      <el-upload
                        class="avatar-uploader"
                        multiple
                        drag
                        action="https://api.sqnetsoft.cn/ossupload/uploadoss"
                        :data="upparams"
                        :on-success="OnHTSuccess"
                        :on-error="OnHTError"
                        :before-upload="BeforeHTUpload">
                      </el-upload>
                    </el-form-item>
                  </el-form>
                </div></el-col>
                <el-col :span="24"><div class="queryinput">
                  现有合同列表：
                  <el-table
                    :data="otnumurldata"
                    style="width: 100%">
                    <el-table-column
                      prop="otnumurl"
                      label="合同地址">
                    </el-table-column>
                    <el-table-column
                      prop="address"
                      width="100px"
                      label="操作">
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="查看/下载合同信息" placement="top-start">
                          <i class="fa fa-eye fa-lg ciicon curpointer" v-on:click="seeht(scope.$index, otnumurldata)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除合同信息" placement="top-start">
                          <i class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="delht(scope.$index, otnumurldata)"></i>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </el-table>
                </div></el-col>
              </el-row>
            </el-collapse-item>
            <el-collapse-item title="附件资料" name="2">
              <el-row class="querypanel">
                <el-col :span="24"><div class="queryinput">
                  <el-form ref="form"  label-width="120px" label-position="left" class="tabcard">
                    <el-form-item label="上传附件" class="yyzz_upload">
                      <el-upload
                        class="avatar-uploader"
                        multiple
                        drag
                        action="https://api.sqnetsoft.cn/ossupload/uploadoss"
                        :data="upparams"
                        :on-success="OnFJSuccess"
                        :on-error="OnFJError"
                        :before-upload="BeforeFJUpload">
                      </el-upload>
                    </el-form-item>
                  </el-form>
                </div></el-col>
                <el-col :span="24"><div class="queryinput">
                  现有附件列表：
                  <el-table
                    :data="otpurldata"
                    style="width: 100%">
                    <el-table-column
                      prop="otpurl"
                      label="附件名称">
                    </el-table-column>
                    <el-table-column
                      prop="address"
                      width="100px"
                      label="操作">
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="查看/下载附件信息" placement="top-start">
                          <i class="fa fa-eye fa-lg ciicon curpointer" v-on:click="seefj(scope.$index, otpurldata)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除附件信息" placement="top-start">
                          <i class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="delfj(scope.$index, otpurldata)"></i>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </el-table>
                </div></el-col>
              </el-row>
            </el-collapse-item>
          </el-collapse>
          <div class="savebasepanel">
            <el-button type="primary" @click="savezl">保存资料</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="管理者信息">
          <el-collapse v-model="activeNames" accordion >
            <el-collapse-item title="管理人员信息" name="1">
              <el-form ref="form"  label-width="150px" label-position="left" class="tabcard">
                <el-form-item label="姓名">
                  <el-input v-model="glname" placeholder="请输入管理员姓名"></el-input>
                </el-form-item>
                <el-form-item label="身份证号">
                  <el-input v-model="glno" placeholder="请输入管理员身份证号"></el-input>
                </el-form-item>
                <el-form-item label="联系方式">
                  <el-input v-model="glphone" placeholder="请输入管理员手机号码"></el-input>
                </el-form-item>
                <el-form-item label="上传身份证(正面)" class="yyzz_upload">
                  <el-upload
                    class="avatar-uploader"
                    drag
                    action="https://api.sqnetsoft.cn/ossupload/uploadoss"
                    :data="upparams"
                    :on-success="OnManaSuccess"
                    :on-error="OnManaError"
                    :before-upload="BeforeManaUpload">
                    <img v-if="glimgurlok" :src="glimgurl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
                <el-form-item label="上传身份证(反面)" class="yyzz_upload">
                  <el-upload
                    class="avatar-uploader"
                    drag
                    action="https://api.sqnetsoft.cn/ossupload/uploadoss"
                    :data="upparams"
                    :on-success="OnManaBackSuccess"
                    :on-error="OnManaBackError"
                    :before-upload="BeforeManaBackUpload">
                    <img v-if="glbackimgurlok" :src="glbackimgurl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
              </el-form>
            </el-collapse-item>
          </el-collapse>
          <div class="savebasepanel">
            <el-button type="primary" @click="saveglry">保存信息</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="经营信息">
          <el-collapse v-model="activeNames" accordion >
            <el-collapse-item title="基本信息" name="1">
            </el-collapse-item>
          </el-collapse>
          <div class="savebasepanel">
            <el-button @click="ciformvisible = false">取 消</el-button>
            <el-button type="primary" @click="ciformvisible = false">确 定</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="客户位置">
          <el-collapse v-model="activeNames" accordion >
            <el-collapse-item title="位置信息" name="1">
            </el-collapse-item>
          </el-collapse>
          <div class="savebasepanel">
            <el-button type="primary" @click="saveglry">保存信息</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import { Message } from 'element-ui'
import '../../../static/css/my.css'
Vue.prototype.$http = axios
var that
var curpagedata
var curdata
export default {
  name: 'CusInfo',
  mounted: function () {
    console.log('开始创建')
    that = this
    var v = getCookie('cusid')
    this.cur_khid = v
    that = this
    if (that.cur_khid === null) {
      that.$message({
        type: 'info',
        message: 'Cookie已失效，请重新登录!'
      })
      that.$router.push({path: '/'})
    } else {
      var cusinfo = JSON.parse(localStorage.getItem('cusinfo'))
      if (cusinfo === null) {
        var qstr = 'ownerid = ' + that.cur_khid
        console.log('开始读取网络数据')
        console.log(this)
        that.$http({
          url: 'https://api.sqnetsoft.cn/customer/getcus',
          method: 'post',
          data: {
            whereinfo: {'String': qstr, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
              localStorage.setItem('cusinfo', res.data.data)
              curdata = JSON.parse(res.data.data)
              curpagedata = new Array(that.size)
              console.log(curdata)
              curpagedata.splice(0, that.size)
              that.total = curdata.length
              for (var i = (that.curpage - 1) * that.size; i < (that.curpage - 1) * that.size + that.size; i++) {
                if (curdata[i] != null) {
                  curpagedata.push(curdata[i])
                }
              }
              that.mycidata = JSON.parse(JSON.stringify(curpagedata))
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      } else {
        console.log('从本地读取')
        var cusinfostate = localStorage.getItem('cusinfostate')
        if (cusinfostate === '0') {
          that.$message({
            type: 'info',
            message: '您上次保存失败，请重新保存！'
          })
        }
        curdata = JSON.parse(localStorage.getItem('cusinfo'))
        var incurpagedata
        incurpagedata = new Array(that.size)
        incurpagedata.splice(0, that.size)
        that.total = curdata.length
        for (var i = (that.curpage - 1) * that.size; i < (that.curpage - 1) * that.size + that.size; i++) {
          if (curdata[i] != null) {
            incurpagedata.push(curdata[i])
          }
        }
        that.mycidata = JSON.parse(JSON.stringify(incurpagedata))
      }
    }
  },
  data () {
    return {
      mycidata: [],
      ciformvisible: false,
      khid: '',
      activeNames: ['1', '2'],
      activekhzl: ['1', '2'],
      query_cusname: '',
      query_cusno: '',
      cusname: '',
      blnum: '',
      raddress: '',
      maddress: '',
      upparams: {'bucketname': 'wyzb1', 'bucketpath': 'cus'},
      blimgurlok: false,
      blimgurl: '',
      lpname: '',
      lpno: '',
      lpphone: '',
      glname: '',
      glno: '',
      glphone: '',
      cur_khid: '',
      lpimgurlok: false,
      lpimgurl: '',
      lpbackimgurlok: false,
      lpbackimgurl: '',
      glimgurlok: false,
      glimgurl: '',
      glbackimgurlok: false,
      glbackimgurl: '',
      htlist: [],
      fjlist: [],
      otnumurldata: [],
      otpurldata: [],
      currentPage: 1,
      total: 0,
      curpage: 1,
      size: 50,
      loading: false
    }
  },
  methods: {
    handleSelectionChange () {},
    handleSizeChange (val) {
      console.log('每页' + val + '条')
    },
    handleCurrentChange (val) {
      console.log('当前页: ' + val)
      this.curpage = val
      curdata = JSON.parse(localStorage.getItem('cusinfo'))
      curpagedata = new Array(that.size)
      curpagedata.splice(0, this.size)
      for (var i = (that.curpage - 1) * this.size; i < (that.curpage - 1) * this.size + this.size; i++) {
        if (curdata[i] != null) {
          curpagedata.push(curdata[i])
        }
      }
      that.mycidata = JSON.parse(JSON.stringify(curpagedata))
    },
    see (row) {
      console.log('查看客户')
      that.htlist = []
      that.fjlist = []
      that.otnumurldata = []
      that.otpurldata = []
      this.khid = row.id
      this.ciformvisible = true
      var qstr = 'id = ' + row.id
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/getcus',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            var cusdatatmp = JSON.parse(res.data.data)
            console.log(cusdatatmp)
            that.cusname = cusdatatmp[0].name
            that.blnum = cusdatatmp[0].blnum.String
            that.raddress = cusdatatmp[0].raddress.String
            that.maddress = cusdatatmp[0].raddress.String
            if (!cusdatatmp[0].blnumurl.Valid || cusdatatmp[0].blnumurl.String === '') {
              that.blimgurlok = false
              that.blimgurl = ''
            } else {
              that.blimgurlok = true
              that.blimgurl = cusdatatmp[0].blnumurl.String
            }
            that.lpname = cusdatatmp[0].lpname.String
            that.lpno = cusdatatmp[0].lpid.String
            that.lpphone = cusdatatmp[0].lpcontact.String
            if (!cusdatatmp[0].lpidurl.Valid || cusdatatmp[0].lpidurl.String === '') {
              that.lpimgurlok = false
              that.lpimgurl = ''
            } else {
              that.lpimgurlok = true
              that.lpimgurl = cusdatatmp[0].lpidurl.String
            }
            if (!cusdatatmp[0].lpidbackurl.Valid || cusdatatmp[0].lpidbackurl.String === '') {
              that.lpbackimgurlok = false
              that.lpbackimgurl = ''
            } else {
              that.lpbackimgurlok = true
              that.lpbackimgurl = cusdatatmp[0].lpidbackurl.String
            }
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
      var qstr2 = 'cus_id = ' + this.khid

      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/getcusmana',
        method: 'post',
        data: {
          whereinfo: {String: qstr2, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            var cusdatatmp = JSON.parse(res.data.data)
            console.log('cus mana')
            console.log(cusdatatmp)
            that.glname = cusdatatmp[0].mname.String
            that.glno = cusdatatmp[0].mid.String
            that.glphone = cusdatatmp[0].mphone.String
            if (!cusdatatmp[0].midurl.Valid || cusdatatmp[0].midurl.String === '') {
              that.glimgurlok = false
              that.glimgurl = ''
            } else {
              that.glimgurlok = true
              that.glimgurl = cusdatatmp[0].midurl.String
            }
            if (!cusdatatmp[0].bidurl.Valid || cusdatatmp[0].bidurl.String === '') {
              that.glbackimgurlok = false
              that.glbackimgurl = ''
            } else {
              that.glbackimgurlok = true
              that.glbackimgurl = cusdatatmp[0].bidurl.String
            }
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })

      var qstr1 = 'cus_id = ' + this.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/getcusex',
        method: 'post',
        data: {
          whereinfo: {'String': qstr1, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            if (res.data.data !== []) {
              var cuszl = JSON.parse(res.data.data)
              console.log(cuszl[0].otnumurl.String)
              if (cuszl[0].otnumurl.Valid) {
                var otnumurlarr = cuszl[0].otnumurl.String.split(',')
                for (var i = 0; i < otnumurlarr.length; i++) {
                  var otnumurltmp = JSON.parse('{"otnumurl":"' + otnumurlarr[i] + '"}')
                  that.otnumurldata.push(otnumurltmp)
                  that.htlist.push(otnumurlarr[i])
                }
              }
              if (cuszl[0].otpurl.Valid) {
                var otpurlarr = cuszl[0].otpurl.String.split(',')
                for (var j = 0; j < otpurlarr.length; j++) {
                  var otpurltmp = JSON.parse('{"otpurl":"' + otpurlarr[j] + '"}')
                  that.otpurldata.push(otpurltmp)
                  that.fjlist.push(otpurlarr[j])
                }
              }
            }
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    examine (row) {
      console.log('审核客户')
      console.log(row)
      that = this
      this.$confirm('确定审核通过客户 "' + row.name + '" 吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        that.$http({
          url: 'https://api.sqnetsoft.cn/customer/addcusstate',
          method: 'post',
          data: {
            cusid: parseInt(row.id),
            state: {'Int64': 1, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
              that.$message({
                type: 'success',
                message: '审核成功!'
              })
              var qstr = 'ownerid =' + that.cur_khid
              if (that.query_cusname !== null && that.query_cusname !== '') {
                qstr = qstr + " and name like '%" + that.query_cusname + "%' "
              }
              if (that.query_cusno !== null && that.query_cusno !== '') {
                qstr = qstr + " and bl_num like '%" + that.query_cusno + "%'"
              }
              that.$http({
                url: 'https://api.sqnetsoft.cn/customer/getcus',
                method: 'post',
                data: {
                  whereinfo: {String: qstr, Valid: true}
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  if (res.data.success) {
                    localStorage.setItem('cusinfo', res.data.data)
                    curdata = JSON.parse(res.data.data)
                    curpagedata = new Array(that.size)
                    console.log(curdata)
                    curpagedata.splice(0, that.size)
                    that.total = curdata.length
                    for (var i = (that.curpage - 1) * that.size; i < (that.curpage - 1) * that.size + that.size; i++) {
                      if (curdata[i] != null) {
                        curpagedata.push(curdata[i])
                      }
                    }
                    that.mycidata = JSON.parse(JSON.stringify(curpagedata))
                    that.$message({
                      type: 'success',
                      message: '查询完毕!'
                    })
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            } else {
              that.$message({
                type: 'error',
                message: '审核失败!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消审核'
        })
      })
    },
    cancel (index, data) {
      console.log('注销客户')
      var curselectdata = data[index]
      that.loading = true
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/delcus',
        method: 'post',
        data: {
          whereinfo: {'String': 'id=' + curselectdata.id, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            that.loading = false
            that.$message({
              type: 'success',
              message: '注销成功!'
            })
            // 从数据源中查找该数据的索引
            var dataindex = curdata.findIndex(d => d.id === curselectdata.id)
            // 移除该条数据
            curdata.splice(dataindex, 1)
            curpagedata = new Array(that.size)
            curpagedata.splice(0, that.size)
            that.total = curdata.length
            for (var i = (that.curpage - 1) * that.size; i < (that.curpage - 1) * that.size + that.size; i++) {
              if (curdata[i] != null) {
                curpagedata.push(curdata[i])
              }
            }
            localStorage.setItem('cusinfo', JSON.stringify(curpagedata))
            that.mycidata = JSON.parse(JSON.stringify(curpagedata))
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    querycus: function () {
      this.loading = true
      var qstr = 'ownerid =' + this.cur_khid
      if (this.query_cusname !== null && this.query_cusname !== '') {
        qstr = qstr + " and name like '%" + this.query_cusname + "%' "
      }
      if (this.query_cusno !== null && this.query_cusno !== '') {
        qstr = qstr + " and bl_num like '%" + this.query_cusno + "%'"
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/getcus',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.loading = false
            localStorage.setItem('cusinfo', res.data.data)
            curdata = JSON.parse(res.data.data)
            curpagedata = new Array(that.size)
            console.log(curdata)
            curpagedata.splice(0, that.size)
            that.total = curdata.length
            for (var i = (that.curpage - 1) * that.size; i < (that.curpage - 1) * that.size + that.size; i++) {
              if (curdata[i] != null) {
                curpagedata.push(curdata[i])
              }
            }
            that.mycidata = JSON.parse(JSON.stringify(curpagedata))
            that.$message({
              type: 'success',
              message: '查询完毕!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    createcus: function () {
      this.ciformvisible = true
      this.cusname = ''
      this.blnum = ''
      this.raddress = ''
      this.maddress = ''
      this.blimgurlok = false
      this.blimgurl = ''
      this.lpname = ''
      this.lpno = ''
      this.lpphone = ''
      this.lpimgurlok = false
      this.lpimgurl = ''
      this.lpbackimgurlok = false
      this.lpbackimgurl = ''
      this.glname = ''
      this.glno = ''
      this.glphone = ''
      this.glimgurlok = false
      this.glimgurl = ''
      this.glbackimgurlok = false
      this.glbackimgurl = ''
    },
    savezl: function () {
      console.log(this.htlist.toString())
      console.log(this.fjlist.toString())
      that.otnumurldata = []
      that.otpurldata = []
      if (this.khid !== '') {
        that.$http({
          url: 'https://api.sqnetsoft.cn/customer/addcusex',
          method: 'post',
          data: {
            cusid: parseInt(this.khid),
            otnumurl: {'String': this.htlist.toString(), Valid: true},
            otpurl: {'String': this.fjlist.toString(), Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
              that.$message({
                type: 'success',
                message: '保存资料成功!'
              })
              var qstr1 = 'cus_id = ' + that.khid
              that.$http({
                url: 'https://api.sqnetsoft.cn/customer/getcusex',
                method: 'post',
                data: {
                  whereinfo: {'String': qstr1, Valid: true}
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  console.log(res)
                  if (res.data.success) {
                    if (res.data.data !== []) {
                      var cuszl = JSON.parse(res.data.data)
                      console.log(cuszl[0].otnumurl.String)
                      if (cuszl[0].otnumurl.Valid) {
                        var otnumurlarr = cuszl[0].otnumurl.String.split(',')
                        for (var i = 0; i < otnumurlarr.length; i++) {
                          var otnumurltmp = JSON.parse('{"otnumurl":"' + otnumurlarr[i] + '"}')
                          that.otnumurldata.push(otnumurltmp)
                        }
                      }
                      if (cuszl[0].otpurl.Valid) {
                        var otpurlarr = cuszl[0].otpurl.String.split(',')
                        for (var j = 0; j < otpurlarr.length; j++) {
                          var otpurltmp = JSON.parse('{"otpurl":"' + otpurlarr[j] + '"}')
                          that.otpurldata.push(otpurltmp)
                        }
                      }
                    }
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    },
    OnBlError (res) {
      console.log(res)
    },
    OnBlSuccess (res, file, fileList) {
      console.log(res)
      console.log(file)
      console.log(fileList)
      console.log(res.success)
      if (res.success) {
        this.blimgurlok = true
        console.log(res.data[0].osspath)
        this.blimgurl = res.data[0].osspath
      }
      Message.success('上传成功，已上传至OSS存储')
    },
    BeforeBlUpload (file) {
    },
    OnLpError (res) {
      console.log(res)
    },
    OnLpSuccess (res, file, fileList) {
      console.log(res)
      console.log(file)
      console.log(fileList)
      console.log(res.success)
      if (res.success) {
        this.lpimgurlok = true
        console.log(res.data[0].osspath)
        this.lpimgurl = res.data[0].osspath
      }
      Message.success('上传成功，已上传至OSS存储')
    },
    BeforeLpUpload (file) {
    },
    OnLpBackError (res) {
      console.log(res)
    },
    OnLpBackSuccess (res, file, fileList) {
      console.log(res)
      console.log(file)
      console.log(fileList)
      console.log(res.success)
      if (res.success) {
        this.lpbackimgurlok = true
        console.log(res.data[0].osspath)
        this.lpbackimgurl = res.data[0].osspath
      }
      Message.success('上传成功，已上传至OSS存储')
    },
    BeforeLpBackUpload (file) {
    },
    OnHTError (res) {
      console.log(res)
    },
    OnHTSuccess (res, file, fileList) {
      console.log('OnHT')
      if (res.success) {
        that.htlist.push(res.data[0].osspath)
        console.log(res.data[0].osspath)
      }
      Message.success('上传成功，已上传至OSS存储')
    },
    BeforeHTUpload (file) {
    },
    OnFJError (res) {
      console.log(res)
    },
    OnFJSuccess (res, file, fileList) {
      console.log('OnFJ')
      if (res.success) {
        this.fjlist.push(res.data[0].osspath)
        console.log(res.data[0].osspath)
      }
      Message.success('上传成功，已上传至OSS存储')
    },
    BeforeFJUpload (file) {
    },
    savecusinfo: function () {
      console.log(this.cusname)
      console.log(this.blnum)
      console.log(this.raddress)
      console.log(this.maddress)
      console.log(this.blimgurlok)
      console.log(this.blimgurl)
      console.log(this.lpname)
      console.log(this.lpno)
      console.log(this.lpphone)
      console.log(this.lpimgurlok)
      console.log(this.lpimgurl)
      console.log(this.lpbackimgurlok)
      console.log(this.lpbackimgurl)
      if (this.cusname !== '' && this.blnum !== '' && this.raddress !== '' && this.maddress !== '' && this.blimgurl !== '' && this.lpname !== '' && this.lpno !== '' && this.lpphone !== '' && this.lpimgurl !== '' && this.lpbackimgurl !== '') {
        that.$http({
          url: 'https://api.sqnetsoft.cn/customer/addcus',
          method: 'post',
          data: {
            name: that.cusname,
            blnum: {String: that.blnum, Valid: true},
            blinstitutionnum: {String: that.blnum, Valid: true},
            blcreditnum: {String: that.blnum, Valid: true},
            blnumurl: {String: that.blimgurl, Valid: true},
            blinstitutionurl: {String: that.blimgurl, Valid: true},
            raddress: {String: that.raddress, Valid: true},
            maddress: {String: that.maddress, Valid: true},
            validdate: {String: '', Valid: true},
            lpname: {String: that.lpname, Valid: true},
            lpid: {String: that.lpno, Valid: true},
            lpidurl: {String: that.lpimgurl, Valid: true},
            lpidbackurl: {String: that.lpbackimgurl, Valid: true},
            lpcontact: {String: that.lpphone, Valid: true},
            ownerid: {Int64: parseInt(that.cur_khid), Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
              that.$message({
                type: 'success',
                message: '添加成功!'
              })
            } else {
              that.$message({
                type: 'error',
                message: '添加失败!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      } else {
        that.$message({
          type: 'info',
          message: '提交信息不完整!'
        })
      }
    },
    tbclick: function (tbcontext) {
      console.log(tbcontext.index)
      switch (tbcontext.index) {
        case '0': {
          break
        }
        case '1': {
          break
        }
        case '2': {
          break
        }
      }
    },
    seeht (index, data) {
      var curselectdata = data[index]
      console.log(curselectdata.otnumurl)
      window.open(curselectdata.otnumurl, '_blank')
    },
    delht (index, data) {
      var curselectdata = data[index]
      console.log(curselectdata)
      data.splice(index, 1)
      that.htlist.splice(index, 1)
      console.log(data)
      console.log(that.htlist)
      console.log(that.fjlist)
      if (this.khid !== '') {
        that.$http({
          url: 'https://api.sqnetsoft.cn/customer/addcusex',
          method: 'post',
          data: {
            cusid: parseInt(that.khid),
            otnumurl: {'String': that.htlist.toString(), Valid: true},
            otpurl: {'String': that.fjlist.toString(), Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
              that.$message({
                type: 'success',
                message: '删除资料成功!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    },
    seefj (index, data) {
      var curselectdata = data[index]
      console.log(curselectdata.otpurl)
      window.open(curselectdata.otpurl, '_blank')
    },
    delfj (index, data) {
      var curselectdata = data[index]
      console.log(curselectdata)
      data.splice(index, 1)
      that.fjlist.splice(index, 1)
      console.log(data)
      console.log(that.htlist)
      console.log(that.fjlist)
      if (this.khid !== '') {
        that.$http({
          url: 'https://api.sqnetsoft.cn/customer/addcusex',
          method: 'post',
          data: {
            cusid: parseInt(that.khid),
            otnumurl: {'String': that.htlist.toString(), Valid: true},
            otpurl: {'String': that.fjlist.toString(), Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
              that.$message({
                type: 'success',
                message: '删除资料成功!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    },
    OnManaError (res) {
      console.log(res)
    },
    OnManaSuccess (res, file, fileList) {
      console.log(res)
      console.log(file)
      console.log(fileList)
      console.log(res.success)
      if (res.success) {
        this.glimgurlok = true
        console.log(res.data[0].osspath)
        this.glimgurl = res.data[0].osspath
      }
      Message.success('上传成功，已上传至OSS存储')
    },
    BeforeManaUpload (file) {
    },
    OnManaBackError (res) {
      console.log(res)
    },
    OnManaBackSuccess (res, file, fileList) {
      console.log(res)
      console.log(file)
      console.log(fileList)
      console.log(res.success)
      if (res.success) {
        this.glbackimgurlok = true
        console.log(res.data[0].osspath)
        this.glbackimgurl = res.data[0].osspath
      }
      Message.success('上传成功，已上传至OSS存储')
    },
    BeforeManaBackUpload (file) {
    },
    saveglry () {
      console.log(this.glname)
      console.log(this.glno)
      if (this.khid !== '') {
        var adata
        adata = {
          mname: {'String': that.glname, Valid: true},
          mid: {'String': that.glno, Valid: true},
          mphone: {'String': that.glphone, Valid: true},
          midurl: {'String': that.glimgurl, Valid: true},
          bidurl: {'String': that.glbackimgurl, Valid: true},
          cusid: parseInt(this.khid)
        }
        that.$http({
          url: 'https://api.sqnetsoft.cn/customer/addcusmana',
          method: 'post',
          data: adata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
              that.$message({
                type: 'success',
                message: '保存信息成功!'
              })
            } else {
              that.$message({
                type: 'error',
                message: '添加失败!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>



// WEBPACK FOOTER //
// src/components/cus/CusInfo.vue